import store              from '@/store'
import enums              from '@/utils/enums'
import { DOCS }           from '@/utils/constants'
import { hasPermission }  from '@/utils'



export default {
    computed: {
        legalDocs: () => store.getters[DOCS.GET_LEGAL_DOCS],
        generalDocs: () => store.getters[DOCS.GET_GENERAL_DOCS],
        hasLegalDocs: () => store.getters[DOCS.HAS_LEGAL_DOCS],
        hasOwnerDocs: () => store.getters[DOCS.HAS_OWNER_DOCS],
        hasDocs: () => store.getters[DOCS.HAS_LEGAL_DOCS] || store.getters[DOCS.HAS_GENERAL_DOCS] || store.getters[DOCS.HAS_OWNER_DOCS],
        docsLoading: () => store.getters[DOCS.IS_LOADING],
        docsError: () => store.getters[DOCS.HAS_ERROR]
    },
    methods: {
        async getDocuments() {
            if(!hasPermission(enums.documentViewProfiles)) return

            const params = {
                ...this.getByEnterpriseParams,
                desiredFields: {
                    active: 0,
                    deleted: 0,
                    blocks: 0,
                    groups: 0,
                    products: 0,
                    validFrom: 0,
                    validTo: 0,
                    itemGroups: 0
                }
            }

            store.dispatch('getDocuments', params)
        },
        async getOwnerDocuments() {
            if(!hasPermission(enums.documentViewProfiles)) return
            const code = this.selectedUnit.product.code
            const externalSourceId = this.selectedUnit.product.id
            const ownerDocumentActive = true
            const notAcceptEmptyText = true
            const params = {
                filter: { code, externalSourceId, ownerDocumentActive, notAcceptEmptyText },
                desiredFields: {
                  code: 1,
                  externalSourceId: 1,
                  document: 1,
                  links: 1,
                  lastModified: 1
                }
              };

            store.dispatch('getOwnerDocuments', params)
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/modules/docs.js